import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Stepper } from '@/shared/components/Stepper';
import { BasicInfoStep } from './BasicInfoStep';
import { PlansStep } from './PlansStep';
import { CoveragesStep } from './CoveragesStep';
import { RulesStep } from './RulesStep';
import { CalculationsStep } from './CalculationsStep';
import { SummaryStep } from './SummaryStep';
import { BasicInfoStepIcon } from '@/features/agreements/icons/BasicInfoStepIcon';
import { PlansStepIcon } from '@/features/agreements/icons/PlansStepIcon';
import { CoveragesStepIcon } from '@/features/agreements/icons/CoveragesStepIcon';
import { RulesStepIcon } from '@/features/agreements/icons/RulesStepIcon';
import { CalculationStepIcon } from '@/features/agreements/icons/CalculationStepIcon';
import { SummaryStepIcon } from '@/features/agreements/icons/SummaryStepIcon';

export const AgreementForm = ({ action }) => {
  const { id: idFromRoute } = useParams();
  const [agreementId, setAgreementId] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);

  const readOnly = action === 'view';

  const lastStepNextLabel = readOnly
    ? 'Salir'
    : action === 'update'
      ? 'Finalizar'
      : 'Activar convenio';

  useEffect(() => {
    if (action !== 'create' && idFromRoute) {
      setAgreementId(idFromRoute);
    }
  }, [action, idFromRoute]);

  const basicInfoNextRef = useRef(null);
  const plansNextRef = useRef(null);
  const coveragesNextRef = useRef(null);
  const rulesNextRef = useRef(null);
  const calculationsNextRef = useRef(null);
  const summaryNextRef = useRef(null);

  return (
    <Stepper
      items={[
        {
          key: 'basicInfo',
          title: 'Información básica',
          icon: <BasicInfoStepIcon />,
          children: <BasicInfoStep agreementId={agreementId} setAgreementId={setAgreementId} onNextRef={basicInfoNextRef} readOnly={readOnly} />,
          onNext: () => basicInfoNextRef.current?.()
        },
        {
          key: 'plans',
          title: 'Planes',
          icon: <PlansStepIcon />,
          children: <PlansStep agreementId={agreementId} onNextRef={plansNextRef} readOnly={readOnly} />,
          onNext: () => plansNextRef.current?.(),
        },
        {
          key: 'coverages',
          title: 'Coberturas',
          icon: <CoveragesStepIcon />,
          children: <CoveragesStep agreementId={agreementId} onNextRef={coveragesNextRef} readOnly={readOnly} />,
          onNext: () => coveragesNextRef.current?.()
        },
        {
          key: 'rules',
          title: 'Condiciones',
          icon: <RulesStepIcon />,
          children: <RulesStep agreementId={agreementId} onNextRef={rulesNextRef} readOnly={readOnly} />,
          onNext: () => rulesNextRef.current?.()
        },
        {
          key: 'calculations',
          title: 'Cálculo de prima',
          icon: <CalculationStepIcon />,
          children: <CalculationsStep agreementId={agreementId} onNextRef={calculationsNextRef} readOnly={readOnly} />,
          onNext: () => calculationsNextRef.current?.()
        },
        {
          key: 'summary',
          title: 'Resumen',
          icon: <SummaryStepIcon />,
          children: <SummaryStep agreementId={agreementId} onNextRef={summaryNextRef} onGoToStep={setCurrentStep} readOnly={readOnly} action={action} />,
          onNext: async () => {
            const fn = summaryNextRef.current;
            if (fn) return await fn();
          },
        },
      ]}
      step={currentStep}
      onStepChange={setCurrentStep}
      lastStepNextLabel={lastStepNextLabel}
    />
  );
};